package com.meistercharts.charts.pv.stringsPlanning

import com.meistercharts.canvas.command.Command
import com.meistercharts.charts.pv.roofPlanning.Module
import kotlin.uuid.Uuid

/**
 * Every change the strings planning applies to a [PvStringsPlanningModel].
 *
 * The interaction handling creates these and hands them to a [com.meistercharts.canvas.command.CommandExecutor]; it
 * never changes the model itself.
 */
typealias StringsPlanningCommand = Command<PvStringsPlanningModel>

/**
 * Appends a module to the end of a string.
 */
class AppendModuleToString(
  val roofStringUuid: Uuid,
  val module: Module,
) : StringsPlanningCommand {

  override val description: String = "Modul an String anhängen"

  override fun execute(model: PvStringsPlanningModel) {
    model.getRoofString(roofStringUuid).add(module)
  }

  override fun undo(model: PvStringsPlanningModel) {
    model.getRoofString(roofStringUuid).remove(module)
  }
}

/**
 * Removes a module from a string, remembering where it sat so undo puts it back in the same place - the order of the
 * modules is the wiring order and must survive an undo.
 */
class RemoveModuleFromString(
  val roofStringUuid: Uuid,
  val module: Module,
) : StringsPlanningCommand {

  private var previousIndex: Int = -1

  override val description: String = "Modul aus String entfernen"

  override fun execute(model: PvStringsPlanningModel) {
    val roofString = model.getRoofString(roofStringUuid)

    previousIndex = roofString.modules.indexOf(module)
    require(previousIndex >= 0) { "Module is not part of the string: <$module>" }

    roofString.remove(module)
  }

  override fun undo(model: PvStringsPlanningModel) {
    model.getRoofString(roofStringUuid).insert(previousIndex, module)
  }
}

/**
 * Selects the string that is being planned, or clears the selection when [roofStringUuid] is null.
 */
class SelectString(
  val roofStringUuid: Uuid?,
) : StringsPlanningCommand {

  private var previousRoofStringUuid: Uuid? = null

  override val description: String = "String auswählen"

  override fun execute(model: PvStringsPlanningModel) {
    previousRoofStringUuid = model.selectedString?.uuid
    model.set(roofStringUuid)
  }

  override fun undo(model: PvStringsPlanningModel) {
    model.set(previousRoofStringUuid)
  }
}
